import React, { useEffect, useState } from 'react';
import AutoComplete from 'material-ui/AutoComplete';
import useDebounce from 'helpers/useDebounce';
import api from 'services';

function PortsAutoComplete({ 
    selectValue, 
    customValue = '',
    floatingLabelText = '',
    style = {}, 
    textFieldStyle = {}, 
    underlineStyle = {}, 
    floatingLabelStyle = {}, 
    hintText,
    menuStyle = {},
    popoverProps = {},
    inputStyle = {},
    field = '',
    handleChangeCustomValue = (v) => {},
    withAreas = false,
    mainRegions = false,
    onlyAreas,
    shouldClearCustomValue = false,
    isInBalticIndex = false,
    disabled = false,
    name = '',
}) {
    const [portValue, setPortValue] = useState(customValue);
    const [ports, setPorts] = useState([]);
    const [preventFirstSearch, setPreventFirstSearch] = useState(true);

    const debouncedSearchValue = useDebounce(portValue, 500);

    useEffect(() => {
        setPortValue('');
    }, [shouldClearCustomValue]);

    useEffect(() => {
        if (preventFirstSearch) return;

        if (!debouncedSearchValue || debouncedSearchValue.length < 2) {
            handleChangeCustomValue({});
            return;
        }

        api
            .findPortAdmin({
                name: debouncedSearchValue, withAreas, onlyAreas, mainRegions, isInBalticIndex,
            })
            .then((result) => {
                if (mainRegions) {
                    setPorts(result.data.data.filter(p => p.mainRegion));
                } else {
                    setPorts(result.data.data);
                }
            });
    }, [debouncedSearchValue]);

    useEffect(() => {
        setPreventFirstSearch(false);
    }, []);

    useEffect(() => {
        setPortValue(customValue);
    }, [customValue]);

    const choosePort = async (selectedValue, index) => {
        if (index < 0) {
            return;
        }
        await selectValue(selectedValue);
    };

    const changePortValue = (val) => {
        setPortValue(val);
    };

    return (
        <AutoComplete 
            name={name || 'port'}
            value={portValue}
            searchText={portValue}
            dataSource={ports}
            dataSourceConfig={{ text: field || 'name', value: 'item' }}
            hintText={hintText === null ? null : (hintText || 'Port')}
            floatingLabelText={floatingLabelText}
            onUpdateInput={val => changePortValue(val)}
            onNewRequest={(val, index) => choosePort(val, index)}
            filter={AutoComplete.noFilter}
            textFieldStyle={{ fontSize: '13px', height: '72px', ...textFieldStyle }}
            style={style}
            underlineStyle={{ ...underlineStyle }}
            floatingLabelStyle={{ ...floatingLabelStyle }}
            fullWidth={!style.width}
            listStyle={{ overflow: 'auto', maxHeight: '300px' }}
            inputStyle={{ ...inputStyle }}
            popoverProps={{
                canAutoPosition: true,
                ...popoverProps,
            }}
            menuStyle={{ ...menuStyle }}
            disabled={disabled}
        />
    );
}

export default PortsAutoComplete;



// WEBPACK FOOTER //
// ./app/components/common/PortsAutoComplete.jsx